export default __webpack_public_path__ + "static/media/clock2.b3627fad.jpg";